import React from 'react';
import EnhancedMarkdown from '../EnhancedMarkdown/EnhancedMarkdown';
import VerticalContent from '../VerticalContent/VerticalContent';

export type BuildsSubcreationMigrationViewModel = {
  title: string;
  description: string;
};

export default function BuildsSubcreationMigrationSection({
  title,
  description,
}: BuildsSubcreationMigrationViewModel): JSX.Element {
  return (
    <VerticalContent>
      <EnhancedMarkdown
        markdown={`# ${title}
  
${description}
`}
      />
    </VerticalContent>
  );
}
